import HeroSlider from '../components/aravi/HeroSlider';
import Philosophy from '../components/aravi/Philosophy';
import FeaturedResidences from '../components/aravi/FeaturedResidences';
import Sustainability from '../components/aravi/Sustainability';
import Lifestyle from '../components/aravi/Lifestyle';
import Testimonials from '../components/aravi/Testimonials';
import Enquiry from '../components/aravi/Enquiry';

export default function Home() {
  return (
    <>
      <HeroSlider />
      <Philosophy />
      <FeaturedResidences />
      <Sustainability />
      <Lifestyle />
      <Testimonials />
      <Enquiry />
    </>
  );
}
